<template>
  <v-layout row justify-between align-center
            v-on="$listeners"
            class="scope-item" :class="{ actionable, 'has-icon': icon }"
  >
    <v-flex>
      <v-layout row justify-between align-center>
      <v-flex :xs6="subtitle"
              class="scope-item-title"
              :class="{ 'text-clamp': titleClamp }">
        {{ title| capitalize }}
      </v-flex>
      <v-flex :xs6="subtitle" :class="{ 'text-clamp': subtitleClamp }">
        {{ subtitle|formatDate|translate }}
      </v-flex>
      </v-layout>
    </v-flex>
    <v-flex v-if="icon" class="shrink">
      <v-icon v-if="icon" size="24px" color="primary" class="float-right">{{ icon }}</v-icon>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'nx-table-item',
  props: {
    title: String,
    titleClamp: Boolean,
    subtitle: String,
    subtitleClamp: Boolean,
    icon: String,
    actionable: Boolean,
  },
};
</script>

<style lang="stylus" scoped>
.scope-item {
  padding: 0 34px 0 10px;
  align-items: center;
  min-height: 46px;
  border-bottom: 1px solid #a0a0ad;
  font-size: 14px;
  color: #27272e;

  &.actionable {
    cursor: pointer;

    &:hover {
      background-color: #e9e9f2;
    }
  }

  &.has-icon {
    padding-right: 10px
  }

  &-title {
    margin: 8px 0;
  }

  &-value {
    white-space: nowrap;
  }
}
</style>
